import { useLocation } from 'react-router-dom';
// material
import { Container } from '@mui/material';
import { useState, useEffect } from 'react';
// componente
import Page from '../../components/Page';
// layout
import ModuloChat from '../../layouts/chat';

function Chat() {
  const location = useLocation();
  const [openChat, setOpenChat] = useState(true);

  // Fecha o chat quando a rota muda
  useEffect(() => {
    setOpenChat(true); // Abre ao entrar na rota
    return () => setOpenChat(false); // Garante fechar ao sair
  }, [location.key]); // Use .key para detectar cada navegação interna

  return (
    <Page title={`Chat: ${location?.state?.name} | Tecnozap`}>
      <Container>
        <ModuloChat
          key={location?.state?.id}
          open={openChat}
          onClose={() => setOpenChat(false)}
          userChat={location}
        />
      </Container>
    </Page>
  );
}

export default Chat;
